import { StepType } from "./types";

export const STEPS: StepType[] = [
  { title: "Расположение и парковка", path: "/first"},
  { title: "Товары и услуги", path: "/second"},
  { title: "Сервис и обслуживание", path: "/third"},
];

export const FINISH_SCREEN_PATH = "/finish";